__turbopack_context__.v({
  "container": "styleMenu-module-scss-module__UX-V3G__container",
  "demoButton": "styleMenu-module-scss-module__UX-V3G__demoButton",
  "divUtil": "styleMenu-module-scss-module__UX-V3G__divUtil",
  "hamburger": "styleMenu-module-scss-module__UX-V3G__hamburger",
  "hamburgerLanguages": "styleMenu-module-scss-module__UX-V3G__hamburgerLanguages",
  "hamburgerMenus": "styleMenu-module-scss-module__UX-V3G__hamburgerMenus",
  "mainButton": "styleMenu-module-scss-module__UX-V3G__mainButton",
  "menu": "styleMenu-module-scss-module__UX-V3G__menu",
  "menuDiv": "styleMenu-module-scss-module__UX-V3G__menuDiv",
  "menuLinks": "styleMenu-module-scss-module__UX-V3G__menuLinks",
  "mijnMkgLogo": "styleMenu-module-scss-module__UX-V3G__mijnMkgLogo",
  "topBar": "styleMenu-module-scss-module__UX-V3G__topBar",
  "topBarControl": "styleMenu-module-scss-module__UX-V3G__topBarControl",
  "topBarLeft": "styleMenu-module-scss-module__UX-V3G__topBarLeft",
  "topBarLink": "styleMenu-module-scss-module__UX-V3G__topBarLink",
  "topBarRight": "styleMenu-module-scss-module__UX-V3G__topBarRight",
  "utilButtons": "styleMenu-module-scss-module__UX-V3G__utilButtons",
  "utilItem": "styleMenu-module-scss-module__UX-V3G__utilItem",
});
